import { useTheme } from "../context/ThemeContext";
import "./Contact.css";

const Contact = () => {
  const { theme } = useTheme();

  return (
    <div className="contact-page" data-theme={theme}>
      <div className="contact-container">
        <h1>Contact Our Tutor</h1>
        <p className="contact-subtitle">
          Have questions? Reach out to us directly
        </p>
        
        <div className="contact-info">
          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h2>Phone Number</h2>
            <p>+91 98140 81881</p>
          </div>
          
          <div className="contact-card">
            <div className="contact-icon">✉️</div>
            <h2>Email Address</h2>
            <p>sanjaythakur19930@gmail.com</p>
          </div>
        </div>
        
        <div className="contact-note">
          <p>
            Feel free to call or email us for any queries about courses, 
            pricing, or scheduling. We typically respond within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;